import { Action, configureStore, createAsyncThunk, ThunkAction, TypedStartListening } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import basketReducer from "./Reducers/redux-slice-basket";
import filtersReducer from "./Reducers/redux-slice-filters";
import notificationsReducer from "./Reducers/redux-slice-notifications";
import formValidationReducer from "./Reducers/redux-slice-form-validation";
import reactPlayerReducer from "./Reducers/redux-slice-react-player";
import driveSlice from "./Reducers/redux-slice-drive";
import asperaUploadReducer from "./Reducers/redux-slice-aspera-upload";
import assetSlice from "./Reducers/redux-slice-asset";
import newRequestSlice from "./Reducers/redux-slice-new-request";
import settingsUsersSlice from "./Reducers/redux-slice-settings-users";
import groupMessagesSlice from "./Reducers/redux-slice-group-messages";
import showDemoSlice from "./Reducers/redux-slice-show-demo";
import bundleMakerSlice from "./Reducers/redux-slice-bundle-maker";
import objectOrdersSlice from "./Reducers/redux-slice-object-orders";
import timetoolSlice from "./Reducers/redux-slice-timetool";
import layoutSlice from "./Reducers/redux-slice-layout";
import timelineSlice from "./Reducers/redux-slice-timeline";
import treeSlice from "./Reducers/redux-slice-tree";
import workflowDesignerSlice from "./Reducers/redux-slice-workflow-designer";

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

// Redux store includes natively thunk middleware using reduxjs/toolkit
export const reduxStore = configureStore({
  reducer: {
    basket: basketReducer,
    filters: filtersReducer,
    notifications: notificationsReducer,
    formValidation: formValidationReducer,
    reactPlayer: reactPlayerReducer,
    asperaUpload: asperaUploadReducer,
    assetSlice: assetSlice,
    newRequestSlice: newRequestSlice,
    settingsUsersSlice: settingsUsersSlice,
    showDemoSlice: showDemoSlice,
    groupMessagesSlice: groupMessagesSlice,
    bundleMakerSlice: bundleMakerSlice,
    orders: objectOrdersSlice,
    timetoolSlice: timetoolSlice,
    layoutSlice: layoutSlice,
    timeline: timelineSlice,
    workflowDesignerSlice: workflowDesignerSlice,
    driveSlice: driveSlice,
    treeSlice: treeSlice,
  },
});

// ----
// Note for Thunk usage: https://www.appsloveworld.com/reactjs/200/189/why-argument-of-type-asyncthunkactionany-void-is-not-assignable-to-para
// For dispatch() about thunk functions, please use "useAppDispatch(method())"
// ----

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof reduxStore.getState>;
export type AppDispatch = typeof reduxStore.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
